import confetti from 'canvas-confetti';

/** Short celebratory burst when a match ends (win or draw). */
export function fireGameOverConfetti() {
  const origin = { y: 0.62 };
  const base = { origin, zIndex: 10000, disableForReducedMotion: true };

  confetti({
    ...base,
    particleCount: 90,
    spread: 65,
    startVelocity: 42,
  });

  window.setTimeout(() => {
    confetti({
      ...base,
      particleCount: 55,
      spread: 100,
      scalar: 0.85,
      startVelocity: 28,
    });
  }, 180);
}
